import React, { Component } from 'react';
import { UsersIcon, PenToolIcon, CodeIcon, RocketIcon, TrendingUpIcon, ArrowRightIcon } from 'lucide-react';
export function ProcessSection() {
  const steps = [{
    number: '01',
    icon: UsersIcon,
    title: 'Kennismaking',
    description: 'We starten met een vrijblijvend gesprek om jouw wensen, doelen en doelgroep scherp te krijgen.',
    norden: 'https://cdn.magicpatterns.com/uploads/uhiPp3MZg3jPZtHicXL5fS/norden_met_light_bulb.png'
  }, {
    number: '02',
    icon: PenToolIcon,
    title: 'Strategie',
    description: 'We bepalen de juiste aanpak: structuur, content en SEO-strategie voor maximale vindbaarheid in Alkmaar.',
    norden: 'https://cdn.magicpatterns.com/uploads/21QQxdHhdRV8QjVRko8nTz/Norden_met_kleur_waaier.png'
  }, {
    number: '03',
    icon: CodeIcon,
    title: 'Ontwerp',
    description: 'We maken een persoonlijk webdesign dat past bij jouw merk en aanspreekt bij jouw doelgroep.',
    norden: 'https://cdn.magicpatterns.com/uploads/6dZrHEVKNoUSuhGGihoFNM/Norden_met_plant.png'
  }, {
    number: '04',
    icon: RocketIcon,
    title: 'Ontwikkeling',
    description: 'Wij bouwen jouw WordPress website met aandacht voor snelheid, veiligheid en SEO-optimalisatie.',
    norden: 'https://cdn.magicpatterns.com/uploads/bxnkWTg1pmHguiFVCkbcdk/norden_met_laptop_en_gear_15-08.png'
  }, {
    number: '05',
    icon: TrendingUpIcon,
    title: 'Oplevering',
    description: 'Samen lopen we de website door, testen alles en gaan live. Daarna ondersteunen wij je met onderhoud.',
    norden: 'https://cdn.magicpatterns.com/uploads/u5Q7Jx9cFVaD48nmqCDvz9/Norden_met_raket.png'
  }];
  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="werkwijze" className="py-24 lg:py-28 bg-navy-900 relative overflow-hidden" data-id="element-894">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
      backgroundSize: '40px 40px'
    }} data-id="element-895" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-896">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-897">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4" data-id="element-898">
            Hoe wij jouw website bouwen
          </h2>
          <p className="text-navy-300 text-lg max-w-2xl mx-auto" data-id="element-899">
            Een helder proces zonder verrassingen. In vijf stappen van idee naar
            een professionele website in Alkmaar.
          </p>
        </div>

        {/* Steps grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5" data-id="element-900">
          {steps.map(step => {
          const IconComponent = step.icon;
          return <div key={step.number} className="relative bg-white/[0.06] border border-white/10 rounded-2xl px-6 pt-8 pb-7 text-center overflow-hidden" data-id="element-901">
                {/* Large faded step number */}
                <span className="absolute top-3 right-4 text-[5rem] font-extrabold leading-none text-white/[0.04] pointer-events-none select-none" data-id="element-902">
                  {step.number}
                </span>

                {/* Norden per stap */}
                <div className="relative z-10 w-20 h-20 rounded-full bg-accent-light border border-accent/20 flex items-center justify-center mx-auto mb-5 overflow-hidden" data-id="element-903">
                  <img src={step.norden} alt={`Norden bij stap ${step.number}: ${step.title}`} className="w-full h-full object-contain p-1" draggable={false} data-id="element-904" />
                </div>

                {/* Title */}
                <h3 className="relative z-10 text-base font-bold text-white mb-3" data-id="element-905">
                  {step.title}
                </h3>

                {/* Description */}
                <p className="relative z-10 text-navy-400 text-sm leading-relaxed" data-id="element-906">
                  {step.description}
                </p>
              </div>;
        })}
        </div>

        {/* CTA */}
        <div className="mt-14 text-center" data-id="element-907">
          <a href="#contact" onClick={scrollToContact} className="inline-flex items-center justify-center gap-2 bg-accent hover:bg-accent-hover text-white font-semibold px-8 py-4 rounded-button shadow-medium hover:shadow-card transition-all duration-200 text-base group" data-id="element-908">
            Plan een vrijblijvend gesprek
            <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" data-id="element-909" />
          </a>
        </div>
      </div>
    </section>;
}